import {
  CorrectiveWorkFilter,
  IssuesFilter,
  IssuesPageFilters,
  ItemFilter,
  PerformedWorkPageFilters,
  RegularWorkFilter,
  RegularWorkRaisedFromFilter,
  WorkOrderFilter,
  WorkOrderPageFilters,
} from "src/stores/filterStore"
import {
  ENTITY_TYPE,
  INCLUDE_REJECTED,
  INCLUDE_SUPERSEDED,
  PART_OF_WORK_ORDER,
  RAISED_THROUGH,
  WORK_TYPE,
} from "src/util/enums/filters"
import { WorkOrderStateOptions, WorkStateOptions } from "src/util/types/components/sfxTable"

export const FILTER_COLUMN_SEARCH = "search_column"
export const FILTER_COLUMN_VALUE = "column_value"
export const FILTER_ENTITY_UUID = "entity_uuid"

export const ISSUE_FILTER_STATE = [
  "raised",
  "in_work_order",
  "corrected",
  "closed",
  "corrected_closed",
]
export const PERFORMED_WORK_FILTER_STATE: WorkStateOptions[] = [
  "unreviewed",
  "not_applicable",
  "accepted",
  "rejected",
]
export const WORK_ORDER_FILTER_STATE: WorkOrderStateOptions[] = [
  "draft",
  "planned",
  "open",
  "in_progress",
  "behind",
  "overdue",
  "complete",
  "closed",
  "complete_closed",
]

export const ISSUE_FILTERS_DEFAULT: IssuesFilter = {
  isRangeTemporal: false,
  raisedSimple: {
    timeLine: "latest",
    operator: "less-than",
    number: undefined,
    calendrical: "days",
  },
  raisedRange: {
    timeLine: "latest",
    startDate: undefined,
    startTime: undefined,
    endDate: undefined,
    endTime: undefined,
  },
  workDomain: undefined,
  priority: [],
  state: undefined,
  designation: undefined,
}

export const REGULAR_WORK_FILTERS_DEFAULT: RegularWorkFilter = {
  isRangeTemporal: false,
  performedSimple: {
    timeLine: "latest",
    operator: "less-than",
    number: undefined,
    calendrical: "days",
  },
  performedRange: {
    timeLine: "latest",
    startDate: undefined,
    startTime: undefined,
    endDate: undefined,
    endTime: undefined,
  },
  workDomain: undefined,
  designation: undefined,
}

export const REGULAR_WORK_RAISED_FROM_FILTERS_DEFAULT: RegularWorkRaisedFromFilter = {
  isRangeTemporal: false,
  performedSimple: {
    timeLine: "latest",
    operator: "less-than",
    number: undefined,
    calendrical: "days",
  },
  performedRange: {
    timeLine: "latest",
    startDate: undefined,
    startTime: undefined,
    endDate: undefined,
    endTime: undefined,
  },
  designation: undefined,
}

export const CORRECTIVE_WORK_FILTERS_DEFAULT: CorrectiveWorkFilter = {
  isRangeTemporal: false,
  performedSimple: {
    timeLine: "latest",
    operator: "less-than",
    number: undefined,
    calendrical: "days",
  },
  performedRange: {
    timeLine: "latest",
    startDate: undefined,
    startTime: undefined,
    endDate: undefined,
    endTime: undefined,
  },
  workDomain: undefined,
  designation: undefined,
}

export const WORK_ORDER_FILTERS_DEFAULT: WorkOrderFilter = {
  workType: WORK_TYPE.EITHER,
  isRangeTemporal: false,
  startDateSimple: {
    timeLine: "latest",
    operator: "less-than",
    number: undefined,
    calendrical: "days",
  },
  startDateRange: {
    timeLine: "latest",
    startDate: undefined,
    startTime: undefined,
    endDate: undefined,
    endTime: undefined,
  },
  workDomain: undefined,
  priority: [],
  designation: undefined,
}

export const ITEM_FILTERS_DEFAULT: ItemFilter = {
  itemClass: undefined,
  designation: undefined,
}

export const ISSUE_FILTER_DIALOG_DEFAULT: IssuesPageFilters = {
  hasFilters: false,
  systemLink: undefined,
  workDomain: undefined,
  entityType: ENTITY_TYPE.EITHER,
  raisedThrough: RAISED_THROUGH.EITHER,
  includeSuperseded: INCLUDE_SUPERSEDED.NO,
  includeRejected: INCLUDE_REJECTED.NO,
  priority: [],
  state: [],
  hasItemFilters: false,
  hasRegularWorkFilters: false,
  itemFilter: ITEM_FILTERS_DEFAULT,
  regularWorkFilter: REGULAR_WORK_RAISED_FROM_FILTERS_DEFAULT,
}

export const WORK_ORDER_FILTER_DIALOG_DEFAULT: WorkOrderPageFilters = {
  hasFilters: false,
  systemLink: undefined,
  workDomain: undefined,
  workType: WORK_TYPE.EITHER,
  entityType: ENTITY_TYPE.EITHER,
  priority: [],
  state: [],
  assigned: false,
}

export const PERFORMED_WORK_FILTER_DIALOG_DEFAULT: PerformedWorkPageFilters = {
  hasFilters: false,
  systemLink: undefined,
  workDomain: undefined,
  workType: WORK_TYPE.EITHER,
  entityType: ENTITY_TYPE.EITHER,
  partOfWorkOrder: PART_OF_WORK_ORDER.EITHER,
  itemClass: undefined,
  areaAttributeSet: undefined,
  state: [],
}
